"use client";
import { j as e } from "./index.es16.js";
import { forwardRef as m, useMemo as c } from "react";
import { makeUniqueId as h } from "./index.es109.js";
m(
  ({
    label: d,
    isChecked: o,
    onChange: r,
    isDefaultChecked: s,
    isDisabled: l,
    inputId: i,
    ...t
  }, n) => {
    const a = c(() => h(), []);
    return /* @__PURE__ */ e.jsxs("div", { className: "bl-radio-button", children: [
      /* @__PURE__ */ e.jsx(
        "input",
        {
          ...t,
          ref: n,
          type: "radio",
          id: i || a,
          onChange: r,
          defaultChecked: s,
          disabled: l,
          checked: o
        }
      ),
      /* @__PURE__ */ e.jsx("label", { htmlFor: i || a, children: d })
    ] });
  }
);
//# sourceMappingURL=index.es18.js.map
